"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioConfigKey = void 0;
var StudioConfigKey;
(function (StudioConfigKey) {
    StudioConfigKey["FlowChartMinMapOnOff"] = "FlowChartMinMapOnOff";
    StudioConfigKey["FlowChartLayout"] = "FlowChartLayout";
})(StudioConfigKey = exports.StudioConfigKey || (exports.StudioConfigKey = {}));
